<template>
  <v-row>
    <v-col cols="12">
      <v-stepper class="kbWhite" v-model="step">
        <v-stepper-header>
          <v-stepper-step :complete="step > 1"
                          step="1"
                          color="kbPurple">
            {{ $t('general.campaign') }}
          </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step :complete="step > 2"
                          step="2"
                          color="kbPurple">
            {{ $t('general.people') }}
          </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step :complete="step > 3"
                          step="3"
                          color="kbPurple">
            {{ campaignType === 'sms' ? $t('general.message') : $t('general.subject') }}
          </v-stepper-step>

          <template v-if="campaignType === 'email'">
            <v-divider></v-divider>

            <v-stepper-step :complete="step > 4"
                            step="4"
                            color="kbPurple">
              {{ $t('general.attachFiles') }}
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step :complete="step > 5"
                            step="5"
                            color="kbPurple">
              {{ $t('general.templates') }}
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step :complete="step >= 6"
                            step="6"
                            color="kbPurple">
              {{ $t('general.insertHtmlTemplate') }}
            </v-stepper-step>
          </template>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content step="1">
            <v-row>
              <v-col cols="12" class="text-center mt-4">
                <h3 class="text-center kbDarkBlueText--text" >{{ $t('general.campaignName') }}</h3>
                <span class="kbDarkBlueText--text">{{ $t('general.insertMassCampaignKeyName') }}</span>
              </v-col>
            </v-row>
            <v-row justify="center" >
              <v-text-field class="mx-2 my-4"
                            color="kbDarkBlueText"
                            v-model="campaignName"
                            style="max-width: 400px"
                            outlined
                            single-line
                            clearable>
              </v-text-field>
            </v-row>
            <v-divider/>

            <v-row>
              <v-col cols="12" class="text-center mt-4 mb-4">
                <h3 class="text-center kbDarkBlueText--text">{{ $t('general.campaignType') }}</h3>
              </v-col>
              <v-col cols="12">
                <v-item-group mandatory v-model="campaignType">
                  <v-container fluid>
                    <v-row justify="center">

                      <v-col cols="12" sm="6" md="3" lg="2">
                        <v-item value="sms">
                          <v-card slot-scope="{ active, toggle }"
                                  class="text-center"
                                  :color="active ? 'kbPurple' : 'kbLight'"
                                  :dark="!!active"
                                  @click="toggle">
                            <v-card-text>
                              <v-icon x-large>sms</v-icon><br/><br/>
                              <span class="text-h6">SMS</span>
                            </v-card-text>
                          </v-card>
                        </v-item>
                      </v-col>

                      <v-col cols="12" sm="6" md="3" lg="2">
                        <v-item value="email">
                          <v-card slot-scope="{ active, toggle }"
                                  class="text-center kbGray--text"
                                  :color="active ? 'kbPurple' : 'kbLight'"
                                  :dark="!!active"
                                  @click="toggle">
                            <v-card-text>
                              <v-icon x-large>mail_outline</v-icon><br/><br/>
                              <span class="text-h6">Email</span>
                            </v-card-text>
                          </v-card>
                        </v-item>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-item-group>
              </v-col>
            </v-row>

            <v-divider class="mt-6 mb-4" ></v-divider>
            <v-row>
              <v-col cols="12">
                <v-btn
                  color="kbPurple"
                  dark
                  @click="updateStep()"
                  class="float-right">
                  <span class="hidden-xs-only">{{ $t('general.continue') }}</span>
                  <v-icon dark>keyboard_arrow_right</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-stepper-content>

          <v-stepper-content step="2">
            <campaign-persons :step="step"
                              @interface="step = $event"
                              @changeSelectedList="updateSelectedList($event)">
            </campaign-persons>
          </v-stepper-content>

          <v-stepper-content step="3">
            <campaign-send :step="step"
                           :email="email"
                           :campaignName="campaignName"
                           :campaignType="campaignType"
                           @updateStep="step = $event"
                           :selectedList="selectedList">
            </campaign-send>
          </v-stepper-content>

          <v-stepper-content step="4">
            <AttachCampaignFiles
              :attachments="email.attachments"
              @onFilesChanged="setEmailAttachments"
              @updateStep="step = $event"
            />
          </v-stepper-content>

           <v-stepper-content step="5">
            <html-template-draft :step="step"
                           @draft="step = $event">
            </html-template-draft>
          </v-stepper-content>

          <v-stepper-content step="6">
            <HtmlTemplateCreator :campaignName="campaignName"
                                 :campaignType="campaignType"
                                 :email="email"
                                 :selectedList="selectedList"
                                 @updateStep="step = $event" />
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-col>
  </v-row>
</template>

<script>
import AttachCampaignFiles from '@/pages/App/Communications/NewCampaign/AttachCampaignFiles'
import CampaignPersons from '@/pages/App/Communications/NewCampaign/CampaignPersons'
import CampaignSend from '@/pages/App/Communications/NewCampaign/CampaignSend'
import HtmlTemplateCreator from '@/pages/App/Communications/NewCampaign/HtmlTemplateCreator'
import HtmlTemplateDraft from '@/pages/App/Communications/NewCampaign/HtmlTemplateDraft'
import notifications from '@/libs/notifications'
import { mapState } from 'vuex'
export default {
  components: {
    AttachCampaignFiles,
    CampaignPersons,
    CampaignSend,
    HtmlTemplateCreator,
    HtmlTemplateDraft
  },
  computed: {
    ...mapState({
      listsPersons: state => state.listsPersons.listsPersons
    })
  },
  data () {
    return {
      step: 1,
      campaignName: '',
      campaignType: 'sms',
      email: {
        attachments: [],
        subject: '',
        from: '',
        template: '',
        html: ''
      },
      selectedList: {}
    }
  },
  methods: {
    setEmailAttachments (attachments) {
      this.email.attachments = attachments
    },
    updateSelectedList (listId) {
      if (!listId) {
        this.selectedList = {}
        return
      }

      if (typeof listId === 'object') {
        this.selectedList = listId
      } else {
        this.selectedList = this.listsPersons.find(element => {
          return element._id === listId
        })
      }
    },
    updateStep () {
      if (this.step === 1) {
        if (!this.campaignName) {
          return notifications.error(this.$t('general.insertCampaignName'))
        }

        if (!this.campaignType) {
          return notifications.error(this.$t('general.pickCampaignType'))
        }

        this.step = 2
      }
    }
  }
}
</script>
